var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"form-control",class:_vm.error ? 'is-invalid' : '',attrs:{"placeholder":_vm.placeholder,"inputmode":"numeric"},domProps:{"value":_vm.value},on:{"change":_vm.input}})}
var staticRenderFns = []

export { render, staticRenderFns }